import { Loader } from "@monolith-forensics/monolith-ui";

import {
  DetailsDisplay,
  DetailsDisplayOrientation,
} from "@/Features/_components";
import { useLabAssetContext } from "../Contexts";
import { columnsForAssetType } from "../Tables/LabAssetColumnDefinitions";
import { useLabAssetColumnDefinitions } from "../Tables/useLabAssetColumnDefinitions";

export const LabAssetDetailsDisplay: React.FC<{
  orientation?: DetailsDisplayOrientation;
  style?: React.CSSProperties;
  dataFieldIgnoreList?: string[];
  hideEmptyFields?: boolean;
}> = ({
  orientation = "horizontal",
  style,
  dataFieldIgnoreList = [],
  hideEmptyFields = false,
}) => {
  const labAssetContext = useLabAssetContext();
  if (!labAssetContext) {
    throw new Error("Lab asset context not found");
  }
  const { data, isPending } = labAssetContext;
  const { columnDefinitions: allColumns, isLoading: columnsLoading } =
    useLabAssetColumnDefinitions();

  if (isPending || columnsLoading) {
    return <Loader />;
  }

  // Only the columns tagged for this asset's type: software keeps its display
  // name in `license_name` (so `name` would repeat it) and has no equipment
  // fields, and vice versa; custom fields follow their type_ids. Same rule as
  // the flyout. Custom values render inline as their own columns.
  // asset_number keeps the table's link cell even though it points back at
  // this page: it stays highlighted like everywhere else and supports
  // open-in-new-tab.
  // The page header already shows the due/overdue badge (ENG-1680), so
  // next_validation_due drops the table's badge cell and shows the API's
  // YYYY-MM-DD value as is.
  const columnDefinitions = columnsForAssetType(
    allColumns,
    data?.asset_type
  ).map((col) =>
    col.dataField === "next_validation_due"
      ? { ...col, render: undefined }
      : col
  );

  return (
    <DetailsDisplay
      columnDefinitions={columnDefinitions}
      data={data || {}}
      orientation={orientation}
      style={style}
      dataFieldIgnoreList={dataFieldIgnoreList}
      hideEmptyFields={hideEmptyFields}
    />
  );
};
